// extracted by mini-css-extract-plugin
module.exports = {"page-content":"landing-page-content_page-content__YVkre","page-content__visually-hidden-heading":"landing-page-content_page-content__visually-hidden-heading__wMl89"};